import comp from "./CollaboratorV2ListWithModal";
export default comp;
